import applicationReducer from "application/applicationReducer";
import introReducer from "intro/introReducer";
import basicDetailsReducer from "basic-details/basicDetailsReducer";
import fileDetailsReducer from "file-details/fileDetailsReducer";
import termsReducer from "terms/termsReducer";
import uploadReducer from "upload/uploadReducer";
import submissionReducer from "submission/submissionReducer";

export default (state = {}, action) => {
  const application = applicationReducer(state.application, action);
  const submission = submissionReducer(state.submission, action, application);

  const intro = introReducer(
      state.intro,
      action,
      application,
  )

  const upload = uploadReducer(state.upload, action, submission);
  const terms = termsReducer(state.terms, action);

  const basicDetails = basicDetailsReducer(
      state.basicDetails,
      action,
      submission,
      application,
      intro,
  );

  const details = fileDetailsReducer(
      state.details,
      action,
      submission,
      application,
      intro,
      basicDetails,
  );

  return {
    application,
    submission,
    intro,
    terms,
    upload,
    details,
    basicDetails,
  };
};
